<template>
  <v-row justify="center">
    <v-dialog v-model="visible" persistent scrollable>
      <v-card>
        <v-card-title>
          <span class="headl">ASIGNAR DISPOSITIVO</span>
        </v-card-title>
        <v-card-text style="height: 85vh">
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
              <div class="copy_disp mt-3">
                <div class="copy_disp_colum">
                  <p class="copy_disp_title">Nombre</p>
                  <p>{{ data.name }}</p>
                </div>
                <div class="copy_disp_colum">
                  <p class="copy_disp_title">Cuenta</p>
                  <p>{{ data.email }}</p>
                </div>
                <div class="copy_disp_colum">
                  <p class="copy_disp_title">Rol</p>
                  <p v-if="data.rol != null">
                    {{ data.rol.name }}
                  </p>
                </div>
              </div>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <p class="mb-0">Asignados {{ deviceFilterAssign.length }}</p>
                    <div class="ctn_disp_assign">
                      <div v-for="el in deviceFilterAssign" :key="el._id">
                        <v-checkbox
                          class="checkbox_inline"
                          v-model="data._devices"
                          :value="el"
                          hide-details
                          v-if="
                            el.company._id == data.company._id ||
                            isMaster === true ||
                            rolModule === true
                          "
                        >
                          <template v-slot:label>
                            <div class="item_check">
                              <div class="copy_check">
                                <div v-if="el.subTypeService !== 'Seguridad'">
                                  <img 
                                  class="icon_meter"
                                  src="../../assets/img/electric-meter_1.svg"
                                  alt=""
                                />
                                </div>  
                                <div v-else>
                                  <img v-if="el.typeDeviceS === 'Sensor de Puerta'"
                                  class="icon_meter"
                                  src="../../assets/img/sensor-door.svg"
                                  alt=""
                                />
                                <img v-if="el.typeDeviceS === 'Sensor de Humo'"
                                  class="icon_meter"
                                  src="../../assets/img/detector-smoke.svg"
                                  alt=""
                                />
                                <img v-if="el.typeDeviceS === 'Sensor de Gas'"
                                  class="icon_meter"
                                  src="../../assets/img/detector-gas.svg"
                                  alt=""
                                />
                                <img v-if="el.typeDeviceS === 'Boton de Panico'"
                                  class="icon_meter"
                                  src="../../assets/img/button_panic.svg"
                                  alt=""
                                />
                                </div>  
                              </div>
                              <div class="copy_check _left _top">
                                <span class="nui"
                                  >IDX: <b> {{ `${el.idx}` }}</b></span
                                >
                                <span class="nui"
                                  >NUI: <b> {{ `${el.nui}` }}</b></span
                                >
                                <span class="nui"
                                  >Tipo:
                                  <b>{{ `${el.subTypeService}` }}</b>
                                </span>
                                <span class="nui"
                                  >empresa:
                                  <b>{{ `${el.company.name}` }}</b>
                                </span>
                              </div>
                            </div>
                          </template>
                        </v-checkbox>
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <div class="ctn_search">
                      <v-text-field
                        ref="search"
                        v-model="search"
                        @keypress.13.prevent
                        label="Buscar dispositivo"
                        placeholder="Serial, NUID, etc"
                        hide-details
                      ></v-text-field>
                      <v-btn color="secondary" class="ml-2" @click="ListSearch()">
                        Buscar
                      </v-btn>
                    </div>
                    <div
                      v-if="this.items.length > 0"
                      class="list_result_device"
                    >
                      <v-checkbox
                        v-for="item in this.items"
                        :key="item._id"
                        v-model="data._devices"
                        :value="item"
                        hide-details
                      >
                        <template v-slot:label>
                          <div class="item_check">
                            <div class="copy_check">
                              <img
                                class="icon_meter"
                                src="../../assets/img/electric-meter_1.svg"
                                alt=""
                              />
                              <span class="type text-center">{{ `${item.idx}` }}</span>
                            </div>
                            <div class="copy_check _left">
                              <span class="nui"
                                >NUI: <b> {{ `${item.nui}` }}</b></span
                              >
                              <span class="nui"
                                >Tipo:
                                <b>{{ `${item.subTypeService}` }}</b>
                              </span>
                              <span class="nui"
                                >Serial: <b>{{ `${item.serial}` }}</b>
                              </span>
                            </div>
                            <div class="copy_check _left">
                              <span class="nui"
                                >Empresa:
                                <b>{{ `${item.company.name}` }}</b></span
                              >
                              <span class="nui"
                                >Ciudad: <b>{{ `${item.city}` }}</b></span
                              >
                            </div>
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                    <v-alert
                      v-else
                      dense
                      outlined
                      class="mt-3 text-center"
                    >
                      Ningún resultado
                    </v-alert>
                  </v-col>
                </v-row>
              </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="ctn_btn_shop">
            <v-btn large text @click.stop="show = false">Cerrar</v-btn>
            <v-btn
              :disabled="!valid"
              depressed
              large
              color="primary"
              @click="validate"
              >GUARDAR</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "DeviceAssignComp",
  components: {},
  props: ["visible", "data"],
  data() {
    return {
      form: {
        _devices: [],
      },
      search: "",
      items: [],
      itemsData: [],
      valid: true,
      fieldRules: [(v) => !!v || "El campo es requerido"],
    };
  },
  async created() {},
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.$refs.form.reset();
        this.$emit("close");
      }
    });
  },
  methods: {
    ...mapActions(["updateUserDevice", "alertSnackbar"]),
    validate() {
      if (this.$refs.form.validate()) {
        this.registerForm();
      }
    },
    async getJsonData() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };

          axios
            .get(`device/list?page=1&search=${this.search}`, {
              headers: headerToken,
            })
            .then((res) => {
              let devivesResult = res.data.docs;
              
              this.itemsData  = devivesResult.filter((device) => {
                return !this.deviceFilterAssign.some((d) => d.idx == device.idx);
              });

              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    NormalizeDataDevice() {
      if (this.data._devices != null) {
        let device = this.data._devices.map((item) => {
          if (item.device != null) {
            item = {
              _id: item.device._id,
              idx: item.device.idx,
              nui: item.device.nui,
              serial: item.device.serial,
              city: item.device.city,
              subTypeService: item.device.subTypeService,
              typeDeviceS: item.device?.typeDeviceS ?? null,
              company: item.device.company,
            };
            return item;
          } else {
            item = {
              _id: item._id,
              idx: item.idx,
              nui: item.nui,
              serial: item.serial,
              city: item.city,
              subTypeService: item.subTypeService,
              typeDeviceS: item.device?.typeDeviceS ?? null,
              company: item.company,
            };
            return item;
          }
        });
        this.data._devices = device;
      }

      this.items = this.items.filter((device) => {
        return !this.data._devices.some((d) => d.idx == device.idx);
      });

    },
    async ListSearch() {
      await this.getJsonData();
      if (this.deviceFilterAssign.length != 0 || this.search != "") {
        let duplicate = await this.deviceFilterAssign.filter((item) => {
          if (item.idx == this.search || item.nui == this.search) {
            return item;
          }
        });
        if (duplicate.length > 0) {
          this.alertSnackbar({
            snackbar: true,
            text: "ya tiene asignado este dispositivo",
          });
          this.search = "";
        } else {
           console.log(this.itemsData)
          let filtered = await this.itemsData
            .filter((item) => {
              if (item.nui != undefined && item.nui != null && item.nui != "") {
                item = {
                  _id: item._id,
                  idx: item.idx,
                  nui: item.nui,
                  serial: item.serial,
                  city: item.city,
                  subTypeService: item.subTypeService,
                  typeDeviceS: item.device?.typeDeviceS ?? null,
                  company: item.company,
                };
                return item;
              }
            })
            .filter((item) => {
              return (
                item.idx.toString().indexOf(this.search.toLowerCase()) > -1 ||
                item.nui.indexOf(this.search.toLowerCase()) > -1
              );
            });
          if (filtered.length != 0) {
            this.items = filtered;
          } else {
            this.items = [];
            this.alertSnackbar({
              snackbar: true,
              text: "No se encontro el dispositivo, puede que no este configurado.",
            });
          }
        }
      }
    },
    async registerForm() {
      try {
        let moduleID = [];
        await this.data._devices.map((item) => {
          moduleID.push({
            device: item._id,
          });
        });
        let form = {
          _id: this.data._id,
          _devices: moduleID,
        };
        let newData = await this.updateUserDevice(form);
        this.search = null;
        this.items = [];
        if (newData == 200) {
          this.alertSnackbar({
            snackbar: true,
            text: "Se ha asignado un dispositivo.",
          });
          this.$root.$emit("reload"); // parametro update tabla
        }
        this.show = false;
      } catch (error) {
        this.alertSnackbar({
          snackbar: true,
          text: this.getMessage.message,
        });
      }
    },
  },
  computed: {
    ...mapGetters(["getMessage", "getFilterDevice", "isMaster", "getRol"]),
    rolModule() {
      let item = this.getRol._modules.filter((rol) => {
        if (rol.nameModule == "Usuarios" && rol.checkModule === true) {
          //console.log("---", rol);
          return rol;
        }
      });
      //console.log("item", item[0]);
      if (item[0].checkModule == true) {
        return true;
      } else {
        return false;
      }
    },
    deviceFilterAssign() {
      if (this.data._devices != null) {
        this.NormalizeDataDevice();
        return this.data._devices;
      }
      return [];
    },
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.search = null;
          this.items = [];
          this.$refs.form.reset();
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style lang="scss" scope>
@import "../../assets/scss/base.scss";
.ctn_search {
  display: flex;
  button.v-btn {
    position: relative;
    top: 10px;
  }
}
.copy_disp {
  display: flex;
  flex-direction: row;
  .copy_disp_colum {
    flex: 1 1 auto;
    padding: 0 10px;
  }
  p {
    font-family: "Roboto", sans-serif;
    margin-bottom: 0px;
    font-size: 0.9rem;
    color: $dark-jungle-green;
    font-weight: 500;
    &.copy_disp_title {
      font-size: 0.85rem;
      color: $color-text-grey;
    }
  }
}
.ctn_disp_assign {
  margin-top: 10px;
  padding: 10px;
  height: 160px;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  .dis_assign {
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    border: 1px solid #ddd;
    padding: 2px 4px;
    span {
      &.number {
        font-size: 0.9rem;
      }
      &.title_dis {
        font-size: 0.75rem;
        line-height: 1;
        font-weight: bold;
      }
    }
  }
  p {
    margin-bottom: 0;
    font-weight: 600;
  }
  span {
    font-size: 0.9rem;
  }
}
.list_result_device {
  margin-top: 10px;
  padding: 10px;
  overflow: auto;
  overflow-x: hidden;
  height: 200px;
}
.item_check {
  display: flex;
  flex: 1 1 auto;
  border-radius: 4px;
  border: 1px solid #ddd;
  padding: 5px;
  transition-duration: 0.28s;
  transition-property: box-shadow, transform, opacity;
  &:hover {
    box-shadow: $shadow-1;
  }
  img.icon_meter {
    margin-top: 8px;
    width: 32px;
    height: 32px;
  }
  .copy_check {
    display: flex;
    flex-direction: column;
    &._left {
      margin-left: 10px;
    }
    span {
      font-size: 0.85rem;
      &.nui {
        b {
          color: $dark-jungle-green;
          font-weight: 600;
        }
      }
      &.type {
        font-weight: 600;
        color: rgb(36, 153, 26);
        font-size: 0.7em;
      }
    }
  }
}
</style>
